import store from '@/stores/store'
import {MessageBox} from 'element-ui'
import { Message } from 'element-ui';
import md5 from 'js-md5'
import Vue from 'vue'

export default{
    resizeImage:(imgSource, maxWidth = 4096, minShortSide = 512)=>{
        return new Promise((resolve, reject) => {
            const img = new Image();
            // 如果图片是网络图片，需要设置 CORS 配置
            if (!imgSource.startsWith('data:image')) {
                img.crossOrigin = 'anonymous'; // 设置为 'anonymous' 来允许跨域请求
            }
            // 判断 imgSource 是否是 Base64 编码字符串
            if (imgSource.startsWith('data:image')) {
              // 如果是Base64，直接加载
              img.src = imgSource;
            } else {
              // 如果是URL，加载网络图片
              img.src = imgSource;
            }
        
            img.onload = () => {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
        
              // 获取图片的原始宽高
              const originalWidth = img.width;
              const originalHeight = img.height;
        
              // 计算短边和长边
              let width = originalWidth;
              let height = originalHeight;
        
              const shortSide = Math.min(originalWidth, originalHeight);
              const longSide = Math.max(originalWidth, originalHeight);
        
              // 确保短边 >= minShortSide，且长边 <= maxWidth
              if (shortSide < minShortSide) {
                const scale = minShortSide / shortSide;
                width = originalWidth * scale;
                height = originalHeight * scale;
              }
        
              // 确保长边 <= maxWidth，按比例缩放
              const scaleFactor = Math.min(maxWidth / longSide, 1);
              width = width * scaleFactor;
              height = height * scaleFactor;
        
              // 设置canvas的宽高
              canvas.width = width;
              canvas.height = height;
        
              // 将图像绘制到canvas上
              ctx.drawImage(img, 0, 0, width, height);
        
              // 将canvas内容转换为Base64格式
              const base64Image = canvas.toDataURL('image/jpeg', 0.9); // 0.9为质量参数，可以根据需要调整
        
              resolve(base64Image);
            };
        
            img.onerror = (err) => {
              reject(new Error("Image failed to load: " + err));
            };
          });
    },
    setScrollDoc(isval,top,setAdd=0) {

        // 获取所有父容器
        const parents = document.querySelectorAll('.draw_list_item');

        if (!parents.length) return;

        // 创建主Intersection Observer来检测哪些父元素在可视区内
        const mainObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const parent = entry.target;
                const element = parent.querySelector('.tozan');
                if (!element) return;

                if (entry.isIntersecting) {
                    // 父元素进入可视区，开始跟踪
                    trackElement(parent, element);
                } else {
                    // 父元素离开可视区，停止跟踪并重置位置
                    resetElement(element);
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '20px 0px 0px 0px' // 提前20px检测
        });

        // 跟踪元素位置的函数
        function trackElement(parent, element) {
            const elementWidth = element.offsetWidth;

            function updatePosition() {
                const parentRect = parent.getBoundingClientRect();
                const parentRight = parentRect.right;
                const targetLeft = parentRight - elementWidth;

                // 检查是否在可视区内（考虑20px的顶部偏移）
                const isInViewport = parentRect.top <= -20 && parentRect.bottom >= 20;
                if (isInViewport) {
                    // console.log(parentRect.top);
                        if (parentRect.top > -top) {
                            element.style.top = (Math.abs(parentRect.top)+setAdd) + 'px';
                        }
                    // if(isval){
                    // if (parentRect.top > -300) {
                    //     // element.style.position = 'fixed';
                    //         element.style.top = (Math.abs(parentRect.top))+40 + 'px';
                    // }
                    // }else{
                    //     if (parentRect.top > -490) {
                    //             element.style.top = (Math.abs(parentRect.top)+10) + 'px';
                            
                    //     }
                    // }

                    // 在可视区内 - 固定位置
                    // element.style.top = `${(parent.offsetHeight-parentRect.bottom)/2+150}px`;
                } else {
                    // 不在可视区内 - 恢复绝对定位
                    // resetElement(element);
                    // console.log('触发执行1212');
                    
                    return
                }
            }

            // 初始更新
            updatePosition();

            // 只在跟踪状态下监听滚动和resize
            const scrollHandler = () => {
                if (element._isTracked) {
                    updatePosition();
                }
            };

            const resizeHandler = () => {
                if (element._isTracked) {
                    updatePosition();
                }
            };

            // 标记为正在跟踪
            element._isTracked = true;
            element._updatePosition = updatePosition;
        }

        // 重置元素位置的函数
        function resetElement(element) {
            if (!element._isTracked) return;

            // 重置样式
            element.classList.remove('zanfixed');
            element.style.top = '10px';

            // 清除跟踪标记
            element._isTracked = false;
            delete element._updatePosition;
            delete element._scrollHandler;
            delete element._resizeHandler;
        }

        // 初始化观察所有父元素
        parents.forEach(parent => {
            mainObserver.observe(parent);

            // 初始检查，处理页面加载时已经在可视区的元素
            const rect = parent.getBoundingClientRect();
            if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                const element = parent.querySelector('.tozan');
                if (element) trackElement(parent, element);
            }
        });
    },
    moveElementToFirstById(arr, id) {
        const index = arr.findIndex(item => item.draw_id === id);
        if (index > -1) {
            const element = arr[index];
            // 移除元素
            arr.splice(index, 1);
            // 添加到开头
            arr.unshift(element);
        }
        return arr;
    },
    getFormattedTime: (data) => {
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        if(data==1){
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }else if(data == 4){
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        }else if(data==0){
            return `${month}-${day}`;
        }else if(data==2){
            return `${year}-${month}-${day}`;
        }else if(data == 3){
            return `${month}-${day} ${hours}:${minutes}`;
        }
    },
    animateNumber (current, target, callback,time=10) {
		let isIncreasing = current < target
		let intervalId = setInterval(() => {
		  if ((isIncreasing && current >= target) || (!isIncreasing && current <= target)) {
			clearInterval(intervalId)
			return
		  }
	  
		  current += isIncreasing ? 1 : -1
		  callback(current)
		}, time)
	  },
            	  //随机数
    getRandomInt(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1)) + min;},
    getRandomTimeToday() {
        // 获取当前时间
        const now = new Date();
        
        // 获取今天的起始时间（0点0分0秒）
        const todayStart = new Date(now);
        todayStart.setHours(0, 0, 0, 0);
        
        // 计算当前时间与今天0点的时间差（毫秒）
        const timeDiff = now.getTime() - todayStart.getTime();
        
        // 生成随机时间（在今天0点到当前时间之间）
        const randomTimeValue = todayStart.getTime() + Math.floor(Math.random() * timeDiff);
        const randomTime = new Date(randomTimeValue);
        
        // 格式化日期和时间（补零）
        const format = (num) => num.toString().padStart(2, '0');
        
        const formattedRandom = 
            `${randomTime.getFullYear()}-${format(randomTime.getMonth() + 1)}-${format(randomTime.getDate())} ${format(randomTime.getHours())}:${format(randomTime.getMinutes())}`;
        
        return formattedRandom;
    },
    getIsTime(){
        const storedData = localStorage.getItem('isTodyYouh');

        if (storedData) {
            try {
                const dataObj = JSON.parse(storedData);
                const storedTime = dataObj.time; // 获取存储的时间戳
                
                // 获取今天的0点时间戳（本地时间）
                const now = new Date();
                const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const todayStartTimestamp = todayStart.getTime();
                
                // 比较存储时间戳和今日0点时间戳
                if (storedTime < todayStartTimestamp) {
                // 如果是0点之前存入的，清除该项
                localStorage.removeItem('isTodyYouh');
                localStorage.removeItem('remainingShowTime')
                localStorage.removeItem('paynum')
                console.log('已清除过期的isTodyYouh数据');
                } else {
                console.log('保留有效的isTodyYouh数据');
                }
            } catch (e) {
                console.error('解析isTodyYouh数据失败:', e);
                // 如果数据格式错误，可以选择清除
                localStorage.removeItem('isTodyYouh');
            }
        }
    },
    createErrTip(message) {
        if (message == "vip_expire") {
            // VIP 过期了
            MessageBox.confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
                confirmButtonText: '开通会员',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                store.commit('setisPayPopShow', true)
            }).catch(() => {

            });
            return
        } else if (message == "no_open_vip") {
            // 未开通 VIP
            MessageBox.confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
                confirmButtonText: '开通会员',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                store.commit('setisPayPopShow', true)
            }).catch(() => {

            });
            return
        } else if (message == "no_gift_score") {
            // 积分不足
            MessageBox.confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
                confirmButtonText: '升级套餐',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                store.commit('setisPayPopShow', true)
            }).catch(() => {

            });
            return
        } else if (message == "no_level5_vip") {
            // 未开通 VIP
            MessageBox.confirm("该功能为永久会员专享功能，请升级永久会员后使用", '提示', {
                confirmButtonText: '开通会员',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                store.commit('setisPayPopShow', true)
            }).catch(() => {

            });
            return
        }else if (message == "upgradevip") {
            console.log('列队已满')
            // 队列已满
            MessageBox.confirm('生成任务已达最大', '提示', {
                confirmButtonText: '升级套餐',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                store.commit('setisPayPopShow', true)
            }).catch(() => {

            });
            return
        } else if (message == "no_face_verify") {
            // 实名认证
            store.commit('setRealName', true)
            return
        } else if (message == "retry_num_max") {
            MessageBox.confirm('已超出最大重试次数', '提示', {
                type: 'warning'
            }).then(() => {
            })
            return;
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
        }
        MessageBox.confirm(message, '提示', {
            type: 'warning'
        }).then(() => {
        }).catch(() => {
        })
    },
    //检测存储时间是否过0点
    getIsZeroTime(chechTime) {
        let isTodyYouh = localStorage.getItem(chechTime) || 0
        if (isTodyYouh) {
            try {
                const dataObj = JSON.parse(isTodyYouh);
                const storedTime = dataObj.time; // 获取存储的时间戳

                // 获取今天的0点时间戳（本地时间）
                const now = new Date();
                const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const todayStartTimestamp = todayStart.getTime();

                // 比较存储时间戳和今日0点时间戳
                if (storedTime < todayStartTimestamp) {
                    // 如果是0点之前存入的，清除该项
                    return true
                } else {
                    return false
                }
            } catch (e) {
                // 如果数据格式错误，可以选择清除
                return true
            }
        } else {
            return true
        }
    },
    //创作成功检测是否弹出挽留弹窗
    checkContinuePop(userInfo) {
        setTimeout(() => {
            if(!localStorage.getItem('isFirstCreat')&&(userInfo.vip_type==1||userInfo.vip_type==2||userInfo.vip_type==3)){
                store.commit('setFisYouh', true)
                localStorage.setItem('isFirstCreat',JSON.stringify({time:new Date().getTime()}))
            }
        }, 5000);
    },
    // 复制
    copy_prompt(text){
        if(text){
            const input = document.createElement('input');
            input.value = text;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            Message.success('复制成功')
        }
    },
    //分钟级md5加密
    setMd5Key(data){
      let res = md5(data.toString() + (parseInt((new Date().getTime()/1000)/60)).toString())
      return res
    },

    openKefu() {
        const token = localStorage.getItem('token')
        if (!token || !store.state.isLogin) {
                    store.commit('setShowLogin', true)
          return
        }
        const kfUrl = store.state.userInfo.kefu_url || SITE_BTN_CONFIG.kefu_url.btn_value
        window.open(kfUrl)
    }
}